import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class CohortChannelService {
  private readonly apiPrefix = '/admin/cohort-channels';

  constructor(private api: ApiService) {}

  getChannels(qs = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  createChannel(data: object): Observable<any> {
    return this.api.post(this.apiPrefix, data);
  }

  updateChannel(id: number, data: object): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  deleteChannel(id: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  activate(id: number, sendNotification: boolean): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}/activate`, { sendNotification });
  }

  deactivate(id: number): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/${id}/deactivate`, {});
  }

  getMembers(id: number, qs = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${id}/members${qs}`);
  }

  getAllMembers(id: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/${id}/members/all`);
  }

  removeMember(id: number, userId: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${id}/members/${userId}`);
  }
}
